import type { ReactNode } from "react";
import { Camera } from "lucide-react";
import { conteggio } from "./scritte";

interface Props {
  totale: number;
  condomini: number;
  onAggiungi: () => void;
  /** Sotto i 1024 px, al posto di «Aggiungi bollette»: «Fotografa una bolletta» e «Carica PDF o foto dal telefono». */
  telefono?: ReactNode;
  /** La frase del tetto di bollette: con lei «Aggiungi bollette» è spento e la frase sta sotto. */
  tetto?: string;
}

export function Testata({ totale, condomini, onAggiungi, telefono, tetto }: Props) {
  return (
    <div className="flex flex-col gap-3 sm:grid sm:grid-cols-[1fr_auto] sm:items-start lg:items-center">
      <div className="sm:col-start-1 sm:row-start-1">
        <h2 className="text-lg font-semibold text-text">Preventivo condomini</h2>
        {totale > 0 && (
          <p className="text-sm text-muted-foreground tabular-nums">{conteggio(totale, condomini)}</p>
        )}
      </div>
      {/* fra 640 e 1023 px i pulsanti foto vanno sotto, a tutta larghezza (Fold aperto, variante A del 25/10) */}
      {telefono && <div className="sm:col-span-2 sm:row-start-2">{telefono}</div>}
      <div className={`flex flex-col gap-2 sm:col-start-2 sm:row-start-1 sm:flex-row sm:items-center ${telefono ? "max-sm:-mt-1" : ""}`}>
        <div className={`${telefono ? "hidden lg:flex" : "flex"} flex-col gap-1`}>
          <button
            type="button"
            onClick={onAggiungi}
            disabled={tetto !== undefined}
            className="inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-border bg-surface px-4 text-sm font-medium text-text whitespace-nowrap cursor-pointer enabled:hover:bg-border/60 transition-colors disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
          >
            <Camera size={16} aria-hidden="true" />
            Aggiungi bollette
          </button>
          <p aria-live="polite" className="text-xs text-muted-foreground empty:hidden">{tetto}</p>
        </div>
      </div>
    </div>
  );
}
